module.exports = __webpack_public_path__ + "img/014-Pharmacist.d9f80860.png";